import React from 'react';

import './PrivacyAccount.css';

function PrivacyAccount(props) {

    const generateText = () => {
        let text = 
            "This private key is for the access of " + 
            props.asset + 
            " account. It cannot be used to access any other Astral account.\n" +
            "Make sure that you keep this file as private as possible.\n\n" +
            "NDk3MjQxOTQ4OTE3MDUxOTk4MTM5MDkzMzc3MzU3NTg1MTUwNjc5MjE3NjUxNTY3MDI1ODM3Mjg3MDY1MTI2MjIzODY2NzQ3MTE5MDA=";
        
	return text;
    }

    const downloadKey = () => {
        const element = document.createElement("a");
        const file = new Blob([generateText()], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = "astral_key_" + props.asset + ".txt";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    return (
        <div className="ghost-privacy-transfer-container">
            <div className="ghost-privacy-transfer-header">
                <div className="ghost-privacy-transfer-header-container">
                    <div className="ghost-privacy-transfer-header-container-title">Manage Account</div>
                    <div className="ghost-privacy-transfer-header-container-text">Wrap you GHST to STRL.</div>
                </div>

                <div className="ghost-privacy-transfer-balance">
                    <div className="ghost-privacy-transfer-balance-title">Balance</div>
                    <div className="ghost-privacy-transfer-balance-amount">3.2347 {props.asset}</div>
                </div>

            </div>

            <div className="ghost-privacy-interaction-converter">Make sure that you export your private key for current account before you log out. <b>ONLY</b> with exported key you can access to current account. No other ways to get into your account. This is done only for secureity reason. By default, this machine will have access to your account until you log out.</div>

            <div className="ghost-privacy-interaction-converter">You can easily port this account on any machine and use any Ghost after you've registered Astral Account. This make it difficult to `link` Ghost address to any Astral Address. Feel free to use any `account chains`.</div>

            <div style={{ width: "80%" }} className="ghost-propose-claim-buttons">
                <div style={{ width: "40%"  }} onClick={() => downloadKey()} className="ghost-propose-claim-buttons-button ghost-privacy-button-transfer-adapt">Export Key</div>
                <div style={{ width: "40%"  }} onClick={() => {alert("logged out")}} className="ghost-propose-claim-buttons-button ghost-privacy-button-transfer-adapt">Log Out</div>
            </div>

        </div>
    )

}

export default PrivacyAccount;
